import React from "react";
import "../login/login.css";
import { LOGO } from "../../components/image";
import { useNavigate } from "react-router-dom";

const ResetPassword = () => {
  const navigate = useNavigate();

  const handleUpdatePassword = () => {
    navigate("/login");
  };
  return (
    <>
      <div className="text-start ms-5 mt-5">
        <img src={LOGO} height={40} width={40} />
      </div>
      <div className="d-flex justify-content-center align-items-center full-height">
        <div className="login-box">
          <div className="text-start">Reset Password</div>

          <div className="d-flex align-items-center input-box">
            <input type="password" placeholder="New Password" />
            <ion-icon name="eye-outline"></ion-icon>
          </div>

          <div className="d-flex align-items-center input-box">
            <input type="password" placeholder="Confirm Password" />
            <ion-icon name="eye-outline"></ion-icon>
          </div>

          <button className="btn-form mt-5" onClick={handleUpdatePassword}>
            Update Password
          </button>
        </div>
      </div>
    </>
  );
};

export default ResetPassword;
